import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';

type SEOProps = {
  title?: string;
  description?: string;
  image?: string;
};

const SEO = ({ title, description, image }: SEOProps) => {
  const { pathname } = useLocation();

  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          url
          image
          keywords
        }
      }
    }
  `);

  const { siteMetadata } = site;

  const seo = {
    title: title,
    url: `${siteMetadata.url}${pathname || ``}`,
    keywords: [...siteMetadata.keywords].join(','),
    description: description || siteMetadata.description,
    image: `${image || `${siteMetadata.url}${siteMetadata.image}`}`,
  };

  function removeTrailingSlash(url) {
    const reg = /\S*\/$/g
    const result = reg.test(url);
    if (result)  {
      return url.replace(/\/$/, "")
    }
    return url
  }

  return (
    <Helmet
      htmlAttributes={{ lang: 'en' }}
      titleTemplate={`%s - ${siteMetadata.title}`}
      defaultTitle={siteMetadata.title}
    >
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <link rel="canonical" href={removeTrailingSlash(seo.url)} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={removeTrailingSlash(seo.url)} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      <meta name="twitter:site" content="@predibase" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};
export default SEO;
